import { render } from "./LessonPlaceholder.vue?vue&type=template&id=cb647ede"
import script from "./LessonPlaceholder.vue?vue&type=script&lang=js"
export * from "./LessonPlaceholder.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./LessonPlaceholder.vue?vue&type=style&index=0&id=cb647ede&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__